import { HOST } from '../config';
import { apiGet, apiPost } from '../api';

export const A = {
  REQUEST_GET_PACKING_CONTROL: 'REQUEST_GET_PACKING_CONTROL',
  RECEIVE_GET_PACKING_CONTROL: 'RECEIVE_GET_PACKING_CONTROL',
  ERROR_GET_PACKING_CONTROL: 'ERROR_GET_PACKING_CONTROL',

  REQUEST_SEND_PACKING_CONTROL: 'REQUEST_SEND_PACKING_CONTROL',
  RECEIVE_SEND_PACKING_CONTROL: 'RECEIVE_SEND_PACKING_CONTROL',
  ERROR_SEND_PACKING_CONTROL: 'ERROR_SEND_PACKING_CONTROL',

  REQUEST_UPDATE_SINGLE_PACKING: 'REQUEST_UPDATE_SINGLE_PACKING',
  RECEIVE_UPDATE_SINGLE_PACKING: 'RECEIVE_UPDATE_SINGLE_PACKING',
  ERROR_UPDATE_SINGLE_PACKING: 'ERROR_UPDATE_SINGLE_PACKING',

  REQUEST_UPDATE_PACKING_BATCH: 'REQUEST_UPDATE_PACKING_BATCH',
  RECEIVE_UPDATE_PACKING_BATCH: 'RECEIVE_UPDATE_PACKING_BATCH',
  ERROR_UPDATE_PACKING_BATCH: 'ERROR_UPDATE_PACKING_BATCH',

  REQUEST_GET_PICKUP_DATES: 'REQUEST_GET_PICKUP_DATES',
  RECEIVE_GET_PICKUP_DATES: 'RECEIVE_GET_PICKUP_DATES',
  ERROR_GET_PICKUP_DATES: 'ERROR_GET_PICKUP_DATES',

  REQUEST_GET_TAKEOUT_LISTS: 'REQUEST_GET_TAKEOUT_LISTS',
  RECEIVE_GET_TAKEOUT_LISTS: 'RECEIVE_GET_TAKEOUT_LISTS',
  ERROR_GET_TAKEOUT_LISTS: 'ERROR_GET_TAKEOUT_LISTS',

  REQUEST_UPDATE_TAKEOUT_LIST: 'REQUEST_UPDATE_TAKEOUT_LIST',
  RECEIVE_UPDATE_TAKEOUT_LIST: 'RECEIVE_UPDATE_TAKEOUT_LIST',
  ERROR_UPDATE_TAKEOUT_LIST: 'ERROR_UPDATE_TAKEOUT_LIST',

  REQUEST_GET_TAKEOUT_PRINT: 'REQUEST_GET_TAKEOUT_PRINT',
  RECEIVE_GET_TAKEOUT_PRINT: 'RECEIVE_GET_TAKEOUT_PRINT',
  ERROR_GET_TAKEOUT_PRINT: 'ERROR_GET_TAKEOUT_PRINT',

  REQUEST_ADD_FBM_TEXT_STICKER: 'REQUEST_ADD_FBM_TEXT_STICKER',
  RECEIVE_ADD_FBM_TEXT_STICKER: 'RECEIVE_ADD_FBM_TEXT_STICKER',
  ERROR_ADD_FBM_TEXT_STICKER: 'ERROR_ADD_FBM_TEXT_STICKER',

  REQUEST_ADD_FBM_PDF_STICKER: 'REQUEST_ADD_FBM_PDF_STICKER',
  RECEIVE_ADD_FBM_PDF_STICKER: 'RECEIVE_ADD_FBM_PDF_STICKER',
  ERROR_ADD_FBM_PDF_STICKER: 'ERROR_ADD_FBM_PDF_STICKER',
};

export const fetchGetPackingControl = () => {
  return (dispatch, getState) => {
    dispatch(requestGetPackingControl());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/orders/packing_control`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPackingControl());
            resolve(res.takeOutPackings);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPackingControl(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPackingControl(err));
        },
      });
    });
  };
};

const requestGetPackingControl = () => {
  return {
    type: A.REQUEST_GET_PACKING_CONTROL,
  };
};

const receiveGetPackingControl = (data) => {
  return {
    type: A.RECEIVE_GET_PACKING_CONTROL,
    data,
  };
};

const errorGetPackingControl = (err) => {
  return {
    type: A.ERROR_GET_PACKING_CONTROL,
    err,
  };
};

export const fetchSendPackingControl = (data) => {
  return (dispatch, getState) => {
    dispatch(requestSendPackingControl());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/packing_control`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveSendPackingControl());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorSendPackingControl(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorSendPackingControl(err));
          reject(err);
        },
      });
    });
  };
};

const requestSendPackingControl = () => {
  return {
    type: A.REQUEST_SEND_PACKING_CONTROL,
  };
};

const receiveSendPackingControl = (data) => {
  return {
    type: A.RECEIVE_SEND_PACKING_CONTROL,
    data,
  };
};

const errorSendPackingControl = (err) => {
  return {
    type: A.ERROR_SEND_PACKING_CONTROL,
    err,
  };
};

export const fetchUpdateSinglePacking = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateSinglePacking());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/packing`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateSinglePacking());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateSinglePacking(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateSinglePacking(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateSinglePacking = () => {
  return {
    type: A.REQUEST_UPDATE_SINGLE_PACKING,
  };
};

const receiveUpdateSinglePacking = (data) => {
  return {
    type: A.RECEIVE_UPDATE_SINGLE_PACKING,
    data,
  };
};

const errorUpdateSinglePacking = (err) => {
  return {
    type: A.ERROR_UPDATE_SINGLE_PACKING,
    err,
  };
};

export const fetchUpdatePackingBatch = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdatePackingBatch());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/packing/batch`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdatePackingBatch());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdatePackingBatch(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdatePackingBatch(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdatePackingBatch = () => {
  return {
    type: A.REQUEST_UPDATE_PACKING_BATCH,
  };
};

const receiveUpdatePackingBatch = (data) => {
  return {
    type: A.RECEIVE_UPDATE_PACKING_BATCH,
    data,
  };
};

const errorUpdatePackingBatch = (err) => {
  return {
    type: A.ERROR_UPDATE_PACKING_BATCH,
    err,
  };
};

export const fetchGetPickupDates = (data) => {
  return (dispatch, getState) => {
    dispatch(requestGetPickupDates());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/pickup_dates?from=${data.from}&to=${data.to}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPickupDates());
            resolve(res.dates);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPickupDates(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPickupDates(err));
        },
      });
    });
  };
};

const requestGetPickupDates = () => {
  return {
    type: A.REQUEST_GET_PICKUP_DATES,
  };
};

const receiveGetPickupDates = (data) => {
  return {
    type: A.RECEIVE_GET_PICKUP_DATES,
    data,
  };
};

const errorGetPickupDates = (err) => {
  return {
    type: A.ERROR_GET_PICKUP_DATES,
    err,
  };
};

export const fetchGetTakeoutLists = (data) => {
  const { size, page, search, id, date_from, date_to } = data;

  let url = `${HOST}/api/lite/takeout_list?size=${size}`;
  if (page) url += `&page=${page}`;
  if (search) url += `&id=${search}`;
  if (date_from) url += `&date_from=${date_from}`;
  if (date_to) url += `&date_to=${date_to}`;

  if (id) url = `${HOST}/api/lite/takeout_list?id=${id}`;

  return (dispatch, getState) => {
    dispatch(requestGetTakeoutLists());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetTakeoutLists());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetTakeoutLists(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPickupDates(err));
        },
      });
    });
  };
};

const requestGetTakeoutLists = () => {
  return {
    type: A.REQUEST_GET_TAKEOUT_LISTS,
  };
};

const receiveGetTakeoutLists = (data) => {
  return {
    type: A.RECEIVE_GET_TAKEOUT_LISTS,
    data,
  };
};

const errorGetTakeoutLists = (err) => {
  return {
    type: A.ERROR_GET_TAKEOUT_LISTS,
    err,
  };
};

export const fetchUpdateTakeoutList = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateTakeoutList());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/takeout_list`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateTakeoutList());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateTakeoutList(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateTakeoutList(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateTakeoutList = () => {
  return {
    type: A.REQUEST_UPDATE_TAKEOUT_LIST,
  };
};

const receiveUpdateTakeoutList = (data) => {
  return {
    type: A.RECEIVE_UPDATE_TAKEOUT_LIST,
    data,
  };
};

const errorUpdateTakeoutList = (err) => {
  return {
    type: A.ERROR_UPDATE_TAKEOUT_LIST,
    err,
  };
};

export const fetchGetTakeoutPrint = (shippingId) => {
  return (dispatch, getState) => {
    dispatch(requestGetTakeoutPrint());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/takeout_list/print?id=${shippingId}&form=act`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetTakeoutPrint());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetTakeoutPrint(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPickupDates(err));
        },
      });
    });
  };
};

const requestGetTakeoutPrint = () => {
  return {
    type: A.REQUEST_GET_TAKEOUT_PRINT,
  };
};

const receiveGetTakeoutPrint = (data) => {
  return {
    type: A.RECEIVE_GET_TAKEOUT_PRINT,
    data,
  };
};

const errorGetTakeoutPrint = (err) => {
  return {
    type: A.ERROR_GET_TAKEOUT_PRINT,
    err,
  };
};

export const fetchAddFbmTextSticker = (data, type) => {
  return (dispatch, getState) => {
    dispatch(requestAddFbmTextSticker());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/${type}/fbm/sticker`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveAddFbmTextSticker());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorAddFbmTextSticker(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorAddFbmTextSticker(err));
        },
      });
    });
  };
};

const requestAddFbmTextSticker = () => {
  return {
    type: A.REQUEST_ADD_FBM_TEXT_STICKER,
  };
};

const receiveAddFbmTextSticker = (data) => {
  return {
    type: A.RECEIVE_ADD_FBM_TEXT_STICKER,
    data,
  };
};

const errorAddFbmTextSticker = (err) => {
  return {
    type: A.ERROR_ADD_FBM_TEXT_STICKER,
    err,
  };
};

export const fetchAddFbmPdfSticker = (formData, type) => {
  return (dispatch, getState) => {
    dispatch(requestAddFbmPdfSticker());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/${type}/fbm/sticker/file`,
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveAddFbmPdfSticker());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorAddFbmPdfSticker(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorAddFbmPdfSticker(err));
        },
      });
    });
  };
};

const requestAddFbmPdfSticker = () => {
  return {
    type: A.REQUEST_ADD_FBM_PDF_STICKER,
  };
};

const receiveAddFbmPdfSticker = (data) => {
  return {
    type: A.RECEIVE_ADD_FBM_PDF_STICKER,
    data,
  };
};

const errorAddFbmPdfSticker = (err) => {
  return {
    type: A.ERROR_ADD_FBM_PDF_STICKER,
    err,
  };
};
